module.exports = __webpack_public_path__ + "img/Comment Gray.4403daf6.svg";